import * as S from "./NavItem.style";
import { useLocation, useNavigate } from "react-router";

interface NavItemProps {
  data: any;
}

export const NavItem = ({ data }: NavItemProps) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <S.NavItem $pathnameSync={pathname.includes(data.path) ? true : false}>
      <S.NavBtn onClick={() => navigate(data.path, { replace: true })}>
        <S.NavBtnIcon>{data.icon}</S.NavBtnIcon>
        <S.NavBtnTitle>{data.title}</S.NavBtnTitle>
      </S.NavBtn>
    </S.NavItem>
  );
};
